"use client";

import React, { useState, useEffect } from "react";
import { get } from "@/app/helpers";
import { useTheme } from "@/app/theme-provider";
import { IMG_URL } from "@/app/config";

export default function ReadSection({
  initialMessages = [],
  initialLanguage = "ml",
}) {
  const { language } = useTheme();
  const [messages, setMessages] = useState(initialMessages);
  const [expandedIndexes, setExpandedIndexes] = useState({});

  useEffect(() => {
    // if (language === initialLanguage) {
    //   return undefined;
    // }

    let isMounted = true;

    get(`website/homepage-messages`)
      .then((res) => {
        if (isMounted) {
          setMessages(res?.data ?? []);
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [initialLanguage, language]);

  const handleToggle = (index) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className="cmpad mt-40">
      <div className="row">
        {messages.map((item, index) => {
          const paragraphs = String(item?.description ?? "").split(/\r\n\r\n/);
          const isExpanded = expandedIndexes[index];

          return (
            <div className="col-lg-6 col-md-6 col-12 mt-3" key={item?.id ?? index}>
              <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-3 col-12">
                  <div className="bord-img-box">
                    <img src={`${IMG_URL}${item.photo}`} alt={item.name} loading="lazy" decoding="async" />
                  </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-9 col-12">
                  <div className="board-name-box">
                    <span className="title-b">{item.title}</span>
                    <label className="title-n lab">{item.name}{item.designation ? ` ${item.designation}` : ""}</label>
                  </div>
                </div>
              </div>

              <div className="board-content">
                <div className={`content-text ${isExpanded ? "expanded" : "collapsed"}`}>
                  {paragraphs.map((para, i) => (
                    <p key={i}>{para}</p>
                  ))}
                </div>
                <button onClick={() => handleToggle(index)} className="read-more-btn">
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
